var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useMemo, useState } from 'react';
import { useGetCustomerApi, useIsCountryCompleted } from '../../hooks';
import { useUpdateCustomerApi } from '../../hooks/api/customer/useUpdateCustomerApi';
import { CustomerStatus, LanguagesOptions, UnitOfMeasureOptions, } from '../../models';
import { useSelector } from 'react-redux';
import { isAuthorizedSelector } from '../../redux';
import { useLanguage } from '../../locale';
export var useCountryFacade = function (onAddCountry, isSelectedTermsDefaultValue, isSelectedPrivacyDefaultValue) {
    var _a = useLanguage(), t = _a[0], locale = _a[2];
    var appLanguage = locale.toUpperCase();
    var _b = useState(), selectedCountry = _b[0], setSelectedCountry = _b[1];
    var _c = useState(isSelectedPrivacyDefaultValue || false), isSelectedPrivacy = _c[0], setIsSelectedPrivacy = _c[1];
    var _d = useState(isSelectedTermsDefaultValue || false), isSelectedTerms = _d[0], setIsSelectedTerms = _d[1];
    var _e = useState(false), isSelectedNewsletter = _e[0], setIsSelectedNewsletter = _e[1];
    var isAuthenticated = useSelector(isAuthorizedSelector);
    // ** API ** //
    var customer = useGetCustomerApi(Boolean(isAuthenticated)).data;
    var updateCountriesApi = useUpdateCustomerApi().mutateAsync;
    // ** DATA ** //
    var email = customer === null || customer === void 0 ? void 0 : customer.email;
    var options = t('countryScreen.labelCountry');
    var value = useMemo(function () {
        if (!selectedCountry) {
            return options;
        }
        return selectedCountry.name;
    }, [selectedCountry, options]);
    var isButtonDisabled = useMemo(function () {
        return !isSelectedPrivacy || !isSelectedTerms;
    }, [isSelectedPrivacy, isSelectedTerms]);
    // ** CALLBACKS ** //
    var onPressIconPrivacy = useCallback(function () { return setIsSelectedPrivacy(function (current) { return !current; }); }, []);
    var onPressIconTerms = useCallback(function () { return setIsSelectedTerms(function (current) { return !current; }); }, []);
    var onPressIconNewsletter = useCallback(function () { return setIsSelectedNewsletter(function (current) { return !current; }); }, []);
    var onCountryInputPress = useCallback(function () {
        onAddCountry &&
            onAddCountry({
                selectedCountry: selectedCountry,
                onConfirmSelection: setSelectedCountry,
            });
    }, [selectedCountry, onAddCountry]);
    var onCountryCompleted = useIsCountryCompleted().onCountryCompleted;
    var onUpdateCountries = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!customer) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, updateCountriesApi({
                            id: customer.id,
                            payload: {
                                privacy: isSelectedPrivacy && isSelectedTerms,
                                newsletter: isSelectedNewsletter,
                                status: CustomerStatus.Active,
                                countryId: selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.id,
                                language: appLanguage,
                                unitSystem: appLanguage === LanguagesOptions.EnglishUS
                                    ? UnitOfMeasureOptions.imperial
                                    : UnitOfMeasureOptions.metric,
                            },
                        })];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, onCountryCompleted()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        customer,
        isSelectedPrivacy,
        isSelectedTerms,
        onCountryCompleted,
        updateCountriesApi,
        selectedCountry,
        isSelectedNewsletter,
        appLanguage,
    ]);
    return {
        updateCountriesApi: updateCountriesApi,
        email: email,
        isButtonDisabled: isButtonDisabled,
        onPressIconPrivacy: onPressIconPrivacy,
        onPressIconTerms: onPressIconTerms,
        onPressIconNewsletter: onPressIconNewsletter,
        isSelectedPrivacy: isSelectedPrivacy,
        isSelectedTerms: isSelectedTerms,
        isSelectedNewsletter: isSelectedNewsletter,
        onUpdateCountries: onUpdateCountries,
        value: value,
        selectedCountry: selectedCountry,
        setSelectedCountry: setSelectedCountry,
        onCountryInputPress: onCountryInputPress,
    };
};
